export default __webpack_public_path__ + "static/media/Man in Black.1058df56.jpg";